import mitt from "mitt";
export const frameEventBus = mitt();
